export default [
  {
    key: 'imagePath',
    type: 'text',
    label: 'лого',
    filterable: false,
    sortable: true,
  },
  {
    key: 'name',
    type: 'text',
    label: 'Название',
    filterable: false,
    sortable: true,
  },
  {
    key: 'code',
    type: 'text',
    label: 'Код',
    filterable: false,
    sortable: true,
  },
  {
    key: 'website',
    type: 'text',
    label: 'Сайт',
    filterable: false,
    sortable: true,
  },
  {
    key: 'address',
    type: 'text',
    label: 'Адрес',
    filterable: false,
    sortable: true,
  },
  {
    key: 'phone',
    type: 'text',
    label: 'Телефон',
    filterable: false,
    sortable: true,
  },
  {
    key: 'email',
    type: 'text',
    label: 'Email',
    filterable: false,
    sortable: true,
  },
];
